export enum CrmImportState {
  IMPORT_PRICEBOOKS = 'IMPORT_PRICEBOOKS',
  FINISHED_CONFIGURATION = 'FINISHED_CONFIGURATION',
}
